import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllPurchaseIntentionsCommand } from '@/app/purchase-intention/commands/get-all-purchase-intentions.command'

const httpClient = new AxiosClient()

export const getAllPurchaseIntentionsCommand = new GetAllPurchaseIntentionsCommand(httpClient, store)
